import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";
import { SafetyConfirmsGetModel } from "@/commons/services/SafetyConfirms";
import Message from "@/commons/models/Message";

/** store state model */
export interface MobileSendSafetyConfirmDetailToOtherUserState extends SafetyConfirmsGetModel {
  /** 値が格納してあるか */
  exist: boolean;
}

/**
 * ### MobileSendSafetyConfirmDetailToOtherUser store
 *
 * - store
 *   - 安否確認詳細画面で必要な情報を保持する
 * - action, mutation
 *   - 安否確認詳細画面で必要な情報を格納する
 */
@Module({ name: "mobileSendSafetyConfirmDetailToOtherUser" })
export default class MobileSendSafetyConfirmDetailToOtherUser extends VuexModule implements MobileSendSafetyConfirmDetailToOtherUserState {
  facilityId = 0;
  id = 0;
  name = "";
  otherUserMessagesSortKey? = [];
  sendedOtherUserLine = false;
  sendedOtherUserMail = false;
  acceptingOtherUserReply = false;
  messagesSortKey = [];
  acceptingFamilyReply = false;
  createUserId = "";
  createUserName = "";
  deleteFlag = true;
  created = 0;
  updated = 0;
  /** 最後に送った家族メッセージ(LINE) */
  latestLineMessage = null;
  /** 最後に送った家族メッセージ(MAIL) */
  latestMailMessage = null;
  exist = false;

  /** stateのgetters */
  get mobileSendSafetyConfirmDetailToOtherUserState(): MobileSendSafetyConfirmDetailToOtherUserState {
    const state: MobileSendSafetyConfirmDetailToOtherUserState = {
      facilityId: this.facilityId,
      id: this.id,
      name: this.name,
      otherUserMessagesSortKey: this.otherUserMessagesSortKey,
      sendedOtherUserLine: this.sendedOtherUserLine,
      sendedOtherUserMail: this.sendedOtherUserMail,
      acceptingOtherUserReply: this.acceptingOtherUserReply,
      messagesSortKey: this.messagesSortKey,
      acceptingFamilyReply: this.acceptingFamilyReply,
      createUserId: this.createUserId,
      createUserName: this.createUserName,
      deleteFlag: this.deleteFlag,
      created: this.created,
      updated: this.updated,
      latestLineMessage: this.latestLineMessage,
      latestMailMessage: this.latestMailMessage,
      exist: this.exist
    };
    return state;
  }

  @Mutation
  private SET_MOBILE_SEND_SAFETY_CONFIRM_DETAIL_TO_OTHER_USER_STATE(state: MobileSendSafetyConfirmDetailToOtherUserState) {
    this.facilityId = state.facilityId;
    this.id = state.id;
    this.name = state.name;
    this.otherUserMessagesSortKey = state.otherUserMessagesSortKey as any;
    (this.sendedOtherUserLine = state.sendedOtherUserLine), (this.sendedOtherUserLine = state.sendedOtherUserLine), (this.acceptingOtherUserReply = state.acceptingOtherUserReply);
    this.messagesSortKey = state.messagesSortKey as any;
    this.acceptingFamilyReply = state.acceptingFamilyReply;
    this.createUserId = state.createUserId;
    this.createUserName = state.createUserName;
    this.deleteFlag = state.deleteFlag;
    this.created = state.created;
    this.updated = state.updated;
    this.exist = true;
    return;
  }

  @Mutation
  private RESET_MOBILE_SEND_SAFETY_CONFIRM_DETAIL_TO_OTHER_USER_STATE() {
    this.facilityId = 0;
    this.id = 0;
    this.name = "";
    this.otherUserMessagesSortKey = [];
    this.sendedOtherUserLine = false;
    this.sendedOtherUserMail = false;
    this.acceptingOtherUserReply = false;
    this.messagesSortKey = [];
    this.acceptingFamilyReply = false;
    this.createUserId = "";
    this.createUserName = "";
    this.deleteFlag = true;
    this.created = 0;
    this.updated = 0;
    this.exist = false;
    return;
  }

  /**
   * ### 安否確認詳細画面で必要な情報を更新する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public updateMobileSendSafetyConfirmDetailToOtherUserState(payload: { state: MobileSendSafetyConfirmDetailToOtherUserState }): void {
    this.SET_MOBILE_SEND_SAFETY_CONFIRM_DETAIL_TO_OTHER_USER_STATE(payload.state);
    return;
  }

  /**
   * ### 安否確認詳細画面で必要な情報を初期化する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public resetMobileSendSafetyConfirmDetailToOtherUserState(): void {
    this.RESET_MOBILE_SEND_SAFETY_CONFIRM_DETAIL_TO_OTHER_USER_STATE();
    return;
  }
}
